<ng-select
	#api
	[labelForId]="type"
	[items]="dropdownList"
	[multiple]="dropdownSettings.multiple"
	[closeOnSelect]="dropdownSettings.closeOnSelect"
	[clearable]="dropdownSettings.clearable"
	[selectOnTab]="dropdownSettings.selectOnTab"
	[virtualScroll]="dropdownSettings.virtualScroll"
	[searchable]="dropdownSettings.searchable"
	[maxSelectedItems]="dropdownSettings.maxSelectedItems"
	[clearAllText]="dropdownSettings.clearAllText"
	[notFoundText]="dropdownSettings.notFoundText"
	bindLabel="itemName"
	(add)="onAdd($event)"
	(open)="onOpen($event)"
	(close)="onClose($event)"
	(remove)="onRemove($event)"
	placeholder="{{ dropdownSettings.placeholder }}"
	[(ngModel)]="selectedItems"
>
	<ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
		<div class="ng-value" *ngIf="items.length > 1">
			<div *ngIf="!isR9" class="ng-value-label">{{ selectedItems.length }} selected</div>
			<div *ngIf="isR9" class="ng-value-label">{{ selectedItems.length }} {{ this.type }} selected</div>
		</div>
		<div class="ng-value" *ngIf="items.length === 1">
			<div class="ng-value-label">{{ items[0].itemName }}</div>
		</div>
	</ng-template>

	<ng-template ng-header-tmp>
		<div>
			<input class="dropdown-search-input" type="text" placeholder="Search" (input)="api.filter($event.target.value)" />
		</div>
		<div *ngIf="type == ADVERTISERS">
			<div *ngIf="selectedItems.length > 0" class="unselect-btn-container">
				<button (click)="unselectAll()" class="btn btn-sm btn-secondary">Unselect all</button>
			</div>
		</div>

		<div
			*ngIf="type != ADVERTISERS && dropdownList.length > 0"
			class="checkbox-container unselect-btn-container select-all-checkbox"
			(click)="toggleAll()"
		>
			<input id="select-all" type="checkbox" name="toggle" [(ngModel)]="selectAll" />
			<div class="checkmark"></div>
			<div title="Select All" class="select-all-label">Select All</div>
		</div>
		<div class="select-content">
			{{ content }}
		</div>
	</ng-template>

	<ng-template ng-option-tmp let-item="item" let-item$="item" let-index="index">
		<div [class.checkbox-container]="true" [class.item-disabled]="type != ADVERTISERS && !item.active">
			<input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
			<div class="checkmark"></div>
			<div class="multiSelectOptions" title="{{ item.itemName }}">{{ item.itemName }}</div>
		</div>
	</ng-template>
</ng-select>
